import { render, staticRenderFns } from "./BaseMitNoAccessPage.vue?vue&type=template&id=56f93f52&scoped=true"
import script from "./BaseMitNoAccessPage.vue?vue&type=script&lang=js"
export * from "./BaseMitNoAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f93f52",
  null
  
)

export default component.exports